var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formGuid)?_c('div',{staticClass:"cta"},[_c('FormRender',{attrs:{"current-step":_vm.currentStep,"form-guid":_vm.formGuid,"override-options":_vm.formOptions,"subscribed-page-guid":_vm.pageGuid},on:{"apply-step":function($event){_vm.currentStep = $event}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }